import { RecommendedVehicle } from '~/contracts/vdp';
import Delivery from '~/icons/DeliveryMedium';
import getMonthAndDay from '~/utilities/date/getMonthAndDay';
import getWeekDay from '~/utilities/date/getWeekDay';
import { LowerSectionItem } from './VehicleTile.styles';

const DeliveryInfo = ({
  vehicle: {
    earliestAvailabilityDate,
    earliestDaysToAvailability = 0,
    price: { transportCost }
  }
}: {
  vehicle: RecommendedVehicle;
}) => {
  if (!earliestAvailabilityDate) return null;
  const deliveryDate =
    earliestDaysToAvailability < 7
      ? getWeekDay(earliestAvailabilityDate)
      : getMonthAndDay(earliestAvailabilityDate);
  const formattedCost = transportCost ? `$${transportCost}` : 'Free';

  return (
    <LowerSectionItem>
      <Delivery className="h-full w-auto fill-none" />
      <div
        className="my-auto text-left text-[12px] font-bold text-blue-7"
        data-qa="get-it-by"
      >
        {formattedCost} Shipping • Get it by {deliveryDate}
      </div>
    </LowerSectionItem>
  );
};

export default DeliveryInfo;
